module.exports = __webpack_public_path__ + "img/scale.f0785d37.svg";